module.exports = __webpack_public_path__ + "media/throw-1.47cd28ef.mp3";